import type { BoardState, Cell, GravityDir, Position, RotationDir } from "./types";

export const ORTHO_DELTAS: Position[] = [
  { row: -1, col: 0 },
  { row: 1, col: 0 },
  { row: 0, col: -1 },
  { row: 0, col: 1 }
];

export function inBounds(size: number, row: number, col: number): boolean {
  return row >= 0 && col >= 0 && row < size && col < size;
}

export function posKey(row: number, col: number): string {
  return `${row},${col}`;
}

export function parsePosKey(key: string): Position {
  const [r, c] = key.split(",").map(Number);
  return { row: r, col: c };
}

export function cloneCell(cell: Cell): Cell {
  if (cell.tile == null) {
    return { kind: cell.kind, tile: null };
  }
  return {
    kind: cell.kind,
    tile: {
      color: cell.tile.color,
      special: cell.tile.special,
      lockHp: cell.tile.lockHp
    }
  };
}

export function cloneBoard(board: BoardState): BoardState {
  return {
    size: board.size,
    gravity: board.gravity,
    crateGravity: board.crateGravity,
    cells: board.cells.map((row) => row.map((cell) => cloneCell(cell)))
  };
}

export function areAdjacent(a: Position, b: Position): boolean {
  return Math.abs(a.row - b.row) + Math.abs(a.col - b.col) === 1;
}

export function rotatePosition(
  size: number,
  pos: Position,
  dir: RotationDir
): Position {
  if (dir === "LEFT") {
    return { row: size - 1 - pos.col, col: pos.row };
  }
  return { row: pos.col, col: size - 1 - pos.row };
}

const DIR_ORDER: GravityDir[] = ["DOWN", "LEFT", "UP", "RIGHT"];

export function rotateGravity(current: GravityDir, dir: RotationDir): GravityDir {
  const idx = DIR_ORDER.indexOf(current);
  if (idx < 0) {
    return current;
  }
  if (dir === "LEFT") {
    return DIR_ORDER[(idx + 1) % DIR_ORDER.length];
  }
  return DIR_ORDER[(idx + DIR_ORDER.length - 1) % DIR_ORDER.length];
}

export function forEachCell(size: number, fn: (row: number, col: number) => void): void {
  for (let row = 0; row < size; row += 1) {
    for (let col = 0; col < size; col += 1) {
      fn(row, col);
    }
  }
}
